import React, { forwardRef } from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import IconButton, { VARIANT } from 'components/IconButton';

export interface ToggleButtonProps extends React.ComponentPropsWithRef<'button'> {
  /** ToggleButton content goes here. */
  children: React.ReactNode;
  /** A boolean flag. If true, the toggleButton is active */
  active?: boolean;
}

/**
 * ToggleButton component
 * All additional props rather than active and children will be forwarded to the root element.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference.
 */
const ToggleButton = forwardRef<HTMLElement, ToggleButtonProps>(({ active, children, ...otherProps }, ref) => getContext(({ theme }) => {
  let resolvedButtonTheme = theme.ICON_BUTTON;
  if (active) {
    resolvedButtonTheme = _merge({}, theme.ICON_BUTTON, { CTA: theme.ICON_BUTTON.TOGGLE });
  }
  return (
    <IconButton theme={resolvedButtonTheme} {...otherProps} ref={ref} changeable variant={active ? VARIANT.callToAction : VARIANT.default}>
      {children}
    </IconButton>
  );
}));

ToggleButton.defaultProps = {
  active: false
};

ToggleButton.displayName = 'ToggleButton';
export default ToggleButton;
